import PlanejamentoAcaoFormFocoAcao from '../../../produto/spa/planejamento-acao/form/PlanejamentoAcaoFormFocoAcao';

export default PlanejamentoAcaoFormFocoAcao;
